// Configuração do assistente de cadastro/atualização em massa (ImportacaoExcelLote)
// a partir das traduções em importacaoExcel.<chave> de src/locales.
export function configuracaoImportacaoExcel(vm, chave, opcoes = {}) {
  const {
    colunas = [],
    colunasSelecao,
    abas = ["dados", "consulta"],
    instrucoes = true,
    params = {},
    rotulos = {},
    ...extra
  } = opcoes;
  const t = (sufixo) => vm.$t(`importacaoExcel.${chave}.${sufixo}`, params);
  const headers = (lista) =>
    lista.map((value) => ({
      text: rotulos[value] || vm.$t(`importacaoExcel.colunas.${value}`),
      value,
    }));
  const listaAbas = abas.map((aba) => ({
    nome: t(`abas.${aba}.nome`),
    descricao: t(`abas.${aba}.descricao`),
  }));
  if (instrucoes) {
    listaAbas.push({
      nome: vm.$t("importacaoExcel.abaInstrucoes.nome"),
      descricao: vm.$t("importacaoExcel.abaInstrucoes.descricao"),
    });
  }
  return {
    titulo: t("titulo"),
    descricao: t("descricao"),
    orientacao: t("orientacao"),
    limiteRegistros: 20000,
    limiteMB: 15,
    abas: listaAbas,
    headersPrevia: headers(colunas),
    ...(colunasSelecao ? { headersSelecao: headers(colunasSelecao) } : {}),
    ...extra,
  };
}
